﻿document.addEventListener('DOMContentLoaded', () => {
    const tabnav = document.querySelector('.tabs');
    const tabcontent = document.querySelector('.tab-content');
    if (tabnav) {
        tabnav.querySelectorAll('a').forEach((a) => {
            a.addEventListener('click', (e) => {
                e.preventDefault();
                tabnav.querySelectorAll('li').forEach((li) => {
                    li.classList.remove('is-active');
                });
                a.parentNode.classList.add('is-active');
                if (tabcontent) {
                    tabcontent.querySelectorAll('.tab').forEach((tab) => {
                        tab.classList.add('is-hidden');
                    });
                    tabcontent.querySelector('.tab' + a.getAttribute('href')).classList.remove('is-hidden');
                }
            });
        });
    }
});